export default __webpack_public_path__ + "static/media/gera-link-min.cce9b0bb.png";